import type { Attribute } from 'types/entities.types';

const COMMON_SEARCHABLE_FIELDS = ['Asset ID', 'Asset Name', 'Description', 'Environment'];

export const getSearchableFields = (attributesMap: Attribute[]): string[] => {
  const dataSourceFields = attributesMap.filter(attr => attr.isSearchable).map(attr => attr.label);
  return [...COMMON_SEARCHABLE_FIELDS, ...dataSourceFields];
};
